/**
 * CardCapture — auth store.
 *
 * Storage mechanism: **localStorage** under the key `cc_auth`, holding a
 * JSON blob `{ token, user }`. The token is our own stateless HS256 JWT
 * issued by `POST /api/v1/auth/google` or `POST /api/v1/test/login`.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 *
 * Tester injection (documented in /app/memory/auth_testing.md):
 *   localStorage.setItem('cc_auth', JSON.stringify({ token: '...', user: {...} }))
 *   window.dispatchEvent(new Event('cc-auth-changed'))
 */

const KEY = "cc_auth";
const EVENT = "cc-auth-changed";

export function readAuth() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.token) return null;
    return parsed;
  } catch (_e) {
    return null;
  }
}

export function writeAuth(auth) {
  if (!auth || !auth.token) {
    localStorage.removeItem(KEY);
  } else {
    localStorage.setItem(KEY, JSON.stringify(auth));
  }
  window.dispatchEvent(new Event(EVENT));
}

export function clearAuth() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
}

export function onAuthChanged(handler) {
  const listener = () => handler(readAuth());
  window.addEventListener(EVENT, listener);
  window.addEventListener("storage", listener); // cross-tab
  return () => {
    window.removeEventListener(EVENT, listener);
    window.removeEventListener("storage", listener);
  };
}

export function authHeader() {
  const a = readAuth();
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}
